module.exports = __webpack_public_path__ + "media/images/home-cc93a435434f3a3c85c8cb69586c58ce.jpg";